<template >
<header class="header">
  <a class="powered-by" href="//ocard.co" target="_blank">
    <img src="//ocard.co/assets/img/powered-by.svg" alt="Powered by Ocard">
  </a>
  <div class="logo">
    <img id="logo" :src="logo">
  </div>
  <h1 class="brand_name">{{ brand }}</h1>
</header>
</template>

<script>
export default {
  name: 'Fixed-Header',
  props: ['brand', 'logo'],
};
</script>

<style lang="sass" scoped>
header
  padding: 10px
  height: 60px
  position: fixed
  top: 0
  left: 0
  right: 0
  z-index: 1030

  background-color: white

  background-position: right center
  background-repeat: no-repeat
  background-size: auto 30px

  backdrop-filter: blur(5px)

  .logo
    position: relative
    width: 40px
    height: 40px
    margin-right: 10px
    float: left

    border-radius: 2px

    &:after
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0

      border: 1px solid rgba(0, 0, 0, 0.1)
      border-radius: 2px

      content: ""

      @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)
        border-width: .5px

    img
      width: 40px
      height: 40px

  h1
    margin: 11px 0 0 0
    color: #333

    font-size: 1rem
    font-weight: 700
    overflow : hidden
    text-overflow : ellipsis
    white-space : nowrap

  .powered-by
    float: right
    display: block
    padding: 6px 0
</style>
